import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; 
import "./CourseRegistrationForm.css";

const CourseRegistrationForm = () => {
  const [isFormVisible] = useState(true); 
  const navigate = useNavigate(); 

  const handleCloseForm = () => {
    navigate(-1); 
  };

  return (
    <div className="app-container">
      {isFormVisible && (
        <div className="popup-overlay">
          <div className="popup">
            <h2>Form</h2>
            <form>
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input type="text" id="name" placeholder="Enter your name" />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input type="email" id="email" placeholder="Enter your email" />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message:</label>
                <textarea
                  id="message"
                  placeholder="Enter your message"
                ></textarea>
              </div>
              <div className="popup-buttons">
                <button type="submit" className="submit-btn">
                  Submit
                </button>
                <button
                  type="button"
                  className="close-btn"
                  onClick={handleCloseForm} // Navigate back on close
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CourseRegistrationForm;
